
<template >
<v-container>
  <v-row>
    <!-- userbar -->
    <v-col lg="2">
      <Userbar>
        <template slot="post-avatar"><v-img :src="user.profilePic"></v-img></template>
        <template slot="username">{{user.username}}</template>
        <template slot="bio">{{user.bio}}</template>
      </Userbar>
    </v-col>

    <!-- spacer -->
    <v-col lg="2">

    </v-col>

    <!-- edit user info -->
    <v-col lg="8">
      <v-card class="px-12">
        <v-card-title class="ml-n4">Edit info</v-card-title>
        <form @submit.prevent="updateProfile">
          <v-row>
              <v-text-field
              v-model="name"
              label="Name"
              clearable
              solo
              ></v-text-field>
          </v-row>

          <v-row>
            <v-text-field
            v-model="username"
            label="Username"
            clearable
            solo
            ></v-text-field>
          </v-row>

          <v-row>
              <v-text-field solo name="profilePic" clearable label="Profile Picture (URL)" id="profilePic" v-model="profilePic">

              </v-text-field>
              <input type="file" ref="fileInput" accept="image/*" @change="onChosen">
          </v-row>

          <v-row>
            <!-- profile pic preview -->

            <!-- :max-height = "noImg ? '0px' : '500px'" -->
            <v-img
            contain
            v-if="profilePic"
            :src="profilePic"
            aspect-ratio="1.7"
            max-height="500px"
            class="d-flex justify-center my-6"
            @error="imgError"
            ></v-img>

          </v-row>

          <v-alert outlined type="info" v-if="noImg">
            Image not found
          </v-alert>

          <v-row>
              <v-textarea
              color="teal"
              name="bio"
              id="bio"
              label="Bio"
              v-model="bio"
              solo
              width="100%"
              >
            </v-textarea>
        </v-row>


        <v-row>
            <v-btn class="mx-2" dark color="indigo" :disabled="!formIsValid" type="submit">
              Update Profile
            </v-btn>
        </v-row>
      </form>
    </v-card>

  </v-col>
</v-row>
</v-container>
</template>

<script>
import Userbar from '@/components/Frontend/UserSidebar.vue'
export default {
data: () => ({
  username: '',
  name:  '',
  profilePic: '',
  bio: '',
  noImg: false,
  profilePicName: '',
}),
components: {
  Userbar,
},
computed: {
  user(){
    return this.$store.state.user
  },
  formIsValid () {
    return this.name !== '' || this.username !== '' || this.profilePic !== '' || this.bio !== '';
  }
},
methods: {
  updateProfile() {
    const postData = {
      name: this.name !== '' ? this.name: this.$store.state.user.name,
      profilePic: this.profilePic !== '' ? this.profilePic: this.$store.state.user.profilePic,
      username: this.username !== '' ? this.username: this.$store.state.user.username,
      bio: this.bio !== '' ? this.bio: this.$store.state.user.bio
    }
    this.$store.dispatch('firebaseUpdateUser', {
      id: this.$store.state.user.id,
      updates: {
        ...postData
      },
      imgName: this.profilePicName
    })
    // commit('setUser', null)
    this.$router.push('/')
  },
  onChosen(event){
    const picture = event.target.files
    let pictureName = picture[0].name
    if(pictureName.lastIndexOf('.')<=0){
      alert('invalid')
    }
    const reader = new FileReader()
    reader.addEventListener('load',()=>{
      this.profilePic = reader.result
    })
    reader.readAsDataURL(picture[0])
    this.profilePicName = picture[0]
  },
  imgError(){
    this.noImg = true;
  }
},
mounted() {

     this.$store.dispatch('firebaseGetDMs')
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('fetchFeed')
    this.$store.dispatch('fetchPrivateFeed')
    this.$store.dispatch('firebaseGetPostInteraction')
    this.$store.dispatch('firebaseDeletePosts')
    this.$store.dispatch('firebaseGetGroupChat')
    this.$store.dispatch('firebaseGetNotifications')
}
}
</script>

<style lang="css" scoped>
</style>
